import { ComponentIds } from '@inter-ikea-core/core';
import { CoreApi } from '@inter-ikea-storageone/range';

export const addExportGlbToMenu = (gui: dat.GUI, coreApi: CoreApi) => {
  const folder = gui.addFolder('Exports');
  const button = {
    add: () => exportScene(coreApi)
  };

  folder.add(button, 'add').name('Export scene as GLB');
};

const exportScene = (coreApi: CoreApi) => {
  const allEntitiesNoRoom = coreApi
    .getServices()
    .entityManager.entities.filter(
      e =>
        !e.hasComponent(ComponentIds.ROOM_PART_COMPONENT_ID) &&
        e.hasComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID)
    );

  const newObjects = new Set<number>();

  allEntitiesNoRoom.forEach(e => {
    const viewerObjectId = coreApi.entities.getObjectId(e);

    if (viewerObjectId) {
      // For some objects we need to get all the children. For e.g. cloth rails and l-dividers
      coreApi.ipexViewer.get_children(viewerObjectId, false, true).forEach(c => newObjects.add(c));
    }
  });

  if (newObjects.size > 0) {
    coreApi.ipexViewer.serialize_glb(Array(...newObjects)).then(files => {
      coreApi.ipexViewer.download_gltf_files(files);
    });
  }
};
